import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {SessionService} from '../../../services/session.service';
import {PaymentService} from '../../../services/payment.service';
import {DeviceDetectorService} from 'ngx-device-detector';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';

@Component({
    selector: 'app-promotional-code',
    templateUrl: './promotional-code.component.html',
    styleUrls: ['./promotional-code.component.scss']
})
export class PromotionalCodeComponent implements OnInit {

    private ngUnsubscribe: Subject<any> = new Subject<any>();
    form: FormGroup;
    errorCodigo: string;
    succesCodigo: string;
    user: any;
    /* VARIABLES PARA SABER SI SON MOVILES */
    isMobile: any = false;
    isTablet: any = false;

    constructor(
        private fb: FormBuilder,
        private sessionService: SessionService,
        private paymentService: PaymentService,
        private deviceService: DeviceDetectorService) {
        this.isMobile = this.deviceService.isMobile();
        this.isTablet = this.deviceService.isTablet();
        this.sessionService.listenCartItems$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(
            () => {
                if (this.form.controls.code.value.length >= 8) {
                    const items = this.sessionService.getCartItems();
                    this.checkCodePromo(this.form.controls.code.value, (items[0].pricing * 100).toString(), this.user.email);
                }
            }
        );
    }

    ngOnInit(): void {
        this.form = this.fb.group({
            code: ['', Validators.compose([Validators.minLength(8), Validators.maxLength(40)])]
        });
        this.form.controls.code.valueChanges.subscribe(
            data => {
                if (data.length >= 8) {
                    const items = this.sessionService.getCartItems();
                    this.checkCodePromo(data, (items[0].pricing * 100).toString(), this.user.email);
                } else if (data === null || data === '' || data === ' ') {
                    this.sessionService.setPromoCode(null);
                    this.errorCodigo = null;
                    this.succesCodigo = null;
                }
            }
        );
    }

    getUser(): any {
        this.user = this.sessionService.getPaymentAccount();
        return this.sessionService.getPaymentAccount();
    }

    checkCodePromo(code: string, amount: string, username: string): void {
        this.paymentService.checkPromo(code, amount, username).subscribe(
            responseCode => {
                if (responseCode.success) {
                    this.sessionService.setPromoCode(responseCode.data);
                    this.addDataLayer();
                    this.succesCodigo = 'Código aplicado correctamente.';
                    this.errorCodigo = null;
                } else {
                    this.succesCodigo = null;
                    if (responseCode.error === 'Salesman coupon just allowed for new users. Username already exists.') {
                        this.errorCodigo = 'Código válido solo para usuarios nuevos.';
                    } else if (responseCode.error ===
                        'Salesman coupon just allowed for new users. Coupon has been used for given username') {
                        this.errorCodigo = 'No puedes utilizar este código 2 veces.';
                    } else {
                        this.errorCodigo = 'Código no válido.';
                        this.sessionService.setPromoCode(null);
                    }
                }
            }
        );
    }

    addDataLayer(): any {
        // @ts-ignore
        window.dataLayer = window.dataLayer || [];
        // @ts-ignore
        dataLayer.push({ecommerce: null});  // Clear the previous ecommerce object.
        // @ts-ignore
        dataLayer.push({
            event: 'checkout',
            ecommerce: {
                checkout: {
                    actionField: {step: 4, option: 'Codigo de Promocion'},
                }
            }
        });
    }

    inSession(): boolean {
        const auth = this.sessionService.getAuthData();
        const sess = this.sessionService.getLoginSession();
        return (auth != null && sess != null && auth !== '' && sess !== '' && auth !== 'null' && sess !== 'null');
    }

}
